import { LatLngTuple } from "leaflet";

export const DEFAULT_ZOOM = 6;
export const STREET_ZOOM = 18;
export const CITY_ZOOM = 15;
export const MAP_CENTER: LatLngTuple = [46.438, 2.219];
